import accountStyles from "../../common/css/Account.module.css";

const AccountBtnWrap = ({children, addClass}) => {
    return (
        <div className={`${accountStyles.account_btn_wrap} ${addClass}`}>{children}</div>
    );
};

export default AccountBtnWrap;
